module.exports = __webpack_public_path__ + "static/img/402-2.8539a0c4.png";